module.exports = __webpack_public_path__ + "static/media/hacktoberfest2020-new.1b1a02f4.svg";